export enum ViewMode {
	CompactMode = 'CompactMode',
	FullMode = 'FullMode'
}
